import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isSignedIn: false,
  loading: false,  // Changed from true to false to prevent infinite loading issues
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action) => {
      // Extract only serializable data from Clerk user object to prevent Redux serialization errors
      const userPayload = action.payload;
      if (userPayload && typeof userPayload === 'object') {
        state.user = {
          id: userPayload.id,
          email: userPayload.emailAddresses?.[0]?.emailAddress || null,
          firstName: userPayload.firstName,
          lastName: userPayload.lastName,
          username: userPayload.username,
          imageUrl: userPayload.imageUrl,
          // Convert Date objects to timestamps to make them serializable
          createdAt: userPayload.createdAt ? (userPayload.createdAt instanceof Date ? userPayload.createdAt.getTime() : userPayload.createdAt) : null,
          lastSignInAt: userPayload.lastSignInAt ? (userPayload.lastSignInAt instanceof Date ? userPayload.lastSignInAt.getTime() : userPayload.lastSignInAt) : null,
          // Add any other serializable fields you need
        };
      } else {
        state.user = userPayload;
      }
      state.isSignedIn = !!action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    clearAuth: (state) => {
      state.user = null;
      state.isSignedIn = false;
      state.token = null;
      state.loading = false;
    },
  },
});

export const { setUser, setLoading, setToken, clearAuth } = authSlice.actions;
export default authSlice.reducer;